import React from 'react'

//Import CSS
import './notfound.css'


const NotFound = () => {
  return (
    <div className='pagenotfound'>Page not found..!!</div>
  )
}

export default NotFound